module.exports = __webpack_public_path__ + "img/8.46cec70a.jpg";